import React from 'react';

//====================Redux======================//
import { useDispatch, useSelector } from 'react-redux'; // Para gestionar el estado global con Redux

//====================Translate======================//
import { useIntl } from 'react-intl'; // Para manejar la internacionalización de los textos

//====================Layouts======================//
import { Dashboard as DashboardLayout } from 'layouts'; // Layout principal para el dashboard

//====================Material UI======================//
import { Box } from '@mui/material'; // Componentes de Material UI como Box y Typography
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'; // Para la tabla de datos y filtro rápido

//====================Styles======================//
import styles from './styles'; // Archivo de estilos personalizados
import { makeStyles } from '@mui/styles'; // Función para aplicar los estilos con makeStyles
import { getColumns } from './columns'; // Función que retorna las columnas de la tabla
import Swal from 'sweetalert2'; // Librería para popups de confirmación
import { blockCorporativeAdmin } from 'js/actions'; // Acción para bloquear o desbloquear corporativos

const useStyles = makeStyles(styles); // Aplicamos los estilos con makeStyles

//====================Componentes======================//

// Componente para la barra de búsqueda rápida en el toolbar
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

export default function UsersByCorps() {
  //====================Variables======================//
  const classes = useStyles(); // Usamos los estilos definidos
  const intl = useIntl(); // Acceso a los textos traducidos
  const { corporatives } = useSelector((state) => state.corporatives); // Obtenemos los corporativos del estado global
  const { user } = useSelector((state) => state.user); // Obtenemos el usuario actual
  const dispatch = useDispatch(); // Usamos el dispatch de Redux para enviar acciones

  //====================Funciones======================//

  // Función que maneja el bloqueo/desbloqueo de un corporativo
  const handleBlockCorporative = (corporative) => {
    // Muestra un popup de confirmación
    Swal.fire({
      title: intl.formatMessage({
        id: `app.users.usersList.${corporative.active === 0 ? 'locked' : 'unlocked'}Crop`,
      }),
      text: `${corporative.name} va a ser ${corporative.active === 0 ? 'Bloquedo' : 'Desbloqueado'}`,
      icon: 'warning', // Icono de advertencia
      showCancelButton: true, // Muestra el botón de cancelación
      confirmButtonText: corporative.active === 0 ? 'Bloquear' : 'Desbloquear', // Texto del botón de confirmación
      cancelButtonText: 'Cancelar', // Texto del botón de cancelación
    }).then((result) => {
      if (result.isConfirmed) {
        // Si la acción es confirmada, muestra un popup de éxito
        Swal.fire({
          title: intl.formatMessage({
            id: `app.users.usersList.${corporative.active === 0 ? 'locked' : 'unlocked'}Crop`,
          }),
          text: `${corporative.name} ${intl.formatMessage({ id: `app.users.usersList.${corporative.active === 0 ? 'locked' : 'unlocked'}CropText` })}`,
          icon: 'success', // Icono de éxito
        });
        // Llama la acción de Redux para bloquear/desbloquear el corporativo
        dispatch(
          blockCorporativeAdmin(
            corporative.id,
            corporative.active === 0 ? 1 : 0 // Cambia el estado activo del corporativo
          )
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Si se cancela la acción, muestra un popup informando que no se realizó la acción
        Swal.fire({
          title: `Corporativo no ${corporative.active === 0 ? 'Bloqueado' : 'Desbloqueado'}`,
          icon: 'info', // Icono informativo
        });
        console.log(`Acción cancelada para ${corporative.name}.`); // Imprime en consola la acción cancelada
      }
    });
  };

  //====================Columnas de la Tabla======================//
  const columns = getColumns(intl, user, handleBlockCorporative); // Llama la función que devuelve las columnas configuradas

  //====================Render======================//
  return (
    <DashboardLayout
      title={intl.formatMessage({ id: 'app.users.usersList.header' })} // Título del dashboard
    >
      <div className={classes.root}>
        {/* <Typography variant="h3" sx={{ mb: 2 }}>
          {intl.formatMessage({ id: 'app.users.usersList.title' })}{' '}
          {/* Título de la lista de usuarios */}
        {/* </Typography> */}
        {/* DataGrid para mostrar la lista de corporativos */}
        <DataGrid
          columns={columns} // Columnas de la tabla
          rows={corporatives} // Filas con la lista de corporativos
          // Deshabilitar la seleccion de filas
          rowSelection={false}
          initialState={{
            ...corporatives.initialState, // Estado inicial de la tabla
            pagination: {
              ...corporatives.initialState?.pagination,
              paginationModel: {
                pageSize: 5, // Tamaño de la página
              },
            },
          }}
          slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
          sx={{
            pt: 2,
            pb: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: 'background.paper', // Color de fondo de la tabla
            border: '1px solid',
            borderColor: 'divider',
            '& .MuiDataGrid-root': {
              border: 'none', // Quitar borde de la tabla
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
              maxHeight: '60px', // Altura máxima de las celdas
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
              maxHeight: '60px', // Altura máxima de las filas
            },
          }}
        />
      </div>
    </DashboardLayout>
  );
}
